import React, { useState, useCallback } from "react";
import axios from "axios";
import HttpAction from "modules/utils/HttpAction";
import ErroCode from "modules/utils/ErrorCode";

const InvestmentContext = React.createContext({
  state: { investmentList: {}, investment: {} },
  actions: {
    getInvestment: () => {},
    getFundList: () => {},
    getCategoryList: () => {},
  },
});

const InvestmentProvider = ({ children }) => {
  const [investment, setInvestment] = useState({});
  const [fund, setFund] = useState({});
  const [fundList, setFundList] = useState([]);
  const [overseasList, setOverseasList] = useState([]);
  const [domesticList, setDomesticList] = useState([]);
  const [fundImage, setFundImage] = useState({});
  const [investTypeList, setInvestTypeList] = useState([]);
  const [categoryList, setCategoryList] = useState([]);

  const [searchOverseasCondition, setSearchOverseasCondition] = useState({
    bizTypeList: [],
    bizRegionList: [],
  });
  const [searchDomesticCondition, setSearchDomesticCondition] = useState({
    bizTypeList: [],
    bizRegionList: [],
  });

  const getFundList = useCallback((pageInfo) => {
    HttpAction({
      url: "api/admin/fund/list",
      method: "get",
      params: {
        page: pageInfo && pageInfo.page,
        records: pageInfo && pageInfo.records,
        fundDisplayYn: pageInfo && pageInfo.fundDisplayYn,
        fundInfoName: pageInfo && pageInfo.fundInfoName,
        fundCategoryName: pageInfo && pageInfo.fundCategoryName,
        fundCategoryId: pageInfo && pageInfo.fundCategoryId,
      },
    }).then((res) => {
      if (res.code === 200) {
        setFundList(res.data);
      } else {
        ErroCode[res.code] && (window.location.href = `${process.env.REACT_APP_LANGUAGE === "en"?"/en":"/kr"}/500`);
      }
    });
  }, []);

  const getFund = useCallback((fundCode, setState) => {
    HttpAction({
      url: "api/admin/fund",
      method: "get",
      params: {
        fundCode: fundCode,
      },
    }).then((res) => {
      if (res.code === 200) {
        setState(res.data);
      } else {
        ErroCode[res.code] && (window.location.href = `${process.env.REACT_APP_LANGUAGE === "en"?"/en":"/kr"}/500`);
      }
    });
  }, []);

  const loadFund = async (fundCode) => {
    return HttpAction({
      url: "api/admin/fund",
      method: "get",
      params: {
        fundCode: fundCode,
      },
    }).then((res) => {
      console.log(2);
      return res;
    });
  };

  const getInvestment = useCallback((investmentId) => {
    HttpAction({
      url: "api/admin/invest",
      method: "get",
      params: {
        investmentId: investmentId,
      },
    }).then((res) => {
      if (res.code === 200) {
        setInvestment(res.data);
      } else {
        ErroCode[res.code] && (window.location.href = `${process.env.REACT_APP_LANGUAGE === "en"?"/en":"/kr"}/500`);
      }
    });
  }, []);

  const getOverseasCondition = useCallback(() => {
    HttpAction({
      url: "api/admin/biz/list/abroad/condition",
      method: "get",
    }).then((res) => {
      if (res.code === 200) {
        setSearchOverseasCondition(res.data);
      } else {
        ErroCode[res.code] && (window.location.href = `${process.env.REACT_APP_LANGUAGE === "en"?"/en":"/kr"}/500`);
      }
    });
  }, []);

  const getOverseasList = useCallback((pageInfo) => {
    HttpAction({
      url: "api/admin/biz/list/abroad",
      method: "get",
      params: {
        page: pageInfo && pageInfo.page,
        records: pageInfo && pageInfo.records,
        bizDisplayYn: pageInfo && pageInfo.bizDisplayYn,
        bizInfoName: pageInfo && pageInfo.bizInfoName,
        bizRegionType: pageInfo && pageInfo.bizRegionType,
        bizTypeCode: pageInfo && pageInfo.bizTypeCode,
      },
    }).then((res) => {
      if (res.code === 200) {
        setOverseasList(res.data);
      } else {
        ErroCode[res.code] && (window.location.href = `${process.env.REACT_APP_LANGUAGE === "en"?"/en":"/kr"}/500`);
      }
    });
  }, []);

  const getDomesticCondition = useCallback(() => {
    HttpAction({
      url: "api/admin/biz/list/domestic/condition",
      method: "get",
    }).then((res) => {
      if (res.code === 200) {
        setSearchDomesticCondition(res.data);
      } else {
        ErroCode[res.code] && (window.location.href = `${process.env.REACT_APP_LANGUAGE === "en"?"/en":"/kr"}/500`);
      }
    });
  }, []);

  const getDomesticList = useCallback((pageInfo) => {
    HttpAction({
      url: "api/admin/biz/list/domestic",
      method: "get",
      params: {
        page: pageInfo && pageInfo.page,
        records: pageInfo && pageInfo.records,
        bizDisplayYn: pageInfo && pageInfo.bizDisplayYn,
        bizInfoName: pageInfo && pageInfo.bizInfoName,
        bizRegionType: pageInfo && pageInfo.bizRegionType,
        bizTypeCode: pageInfo && pageInfo.bizTypeCode,
      },
    }).then((res) => {
      if (res.code === 200) {
        setDomesticList(res.data);
      } else {
        ErroCode[res.code] && (window.location.href = `${process.env.REACT_APP_LANGUAGE === "en"?"/en":"/kr"}/500`);
      }
    });
  }, []);

  const getFundImage = useCallback((fundCateContentId) => {
    HttpAction({
      url: "api/admin/invest/category-content",
      method: "get",
      params: {
        fundCateContentId: fundCateContentId,
      },
    }).then((res) => {
      if (res.code === 200) {
        setFundImage(res.data);
      } else {
        ErroCode[res.code] && (window.location.href = `${process.env.REACT_APP_LANGUAGE === "en"?"/en":"/kr"}/500`);
      }
    });
  }, []);

  const getInvestTypeList = useCallback((pageInfo) => {
    HttpAction({
      url: "api/admin/biz/type/list",
      method: "get",
    }).then((res) => {
      if (res.code === 200) {
        setInvestTypeList(res.data);
      } else {
        ErroCode[res.code] && (window.location.href = `${process.env.REACT_APP_LANGUAGE === "en"?"/en":"/kr"}/500`);
      }
    });
  }, []);

  const createInvestment = useCallback((investmentData, setState) => {
    HttpAction({
      url: "api/admin/invest",
      method: "post",
      data: {
        investmentContent: investmentData.investmentContent,
        investmentDisplayYn: investmentData.investmentDisplayYn,
        investmentEndDate: investmentData.investmentEndDate,
        investmentLinkUrl: investmentData.investmentLinkUrl,
        investmentStartDate: investmentData.investmentStartDate,
        investmentTitle: investmentData.investmentTitle,
        investmentTypeCode: investmentData.investmentTypeCode,
      },
    }).then((res) => {
      if (res.code === 200) {
        setState(true);
      } else {
        setState(false);
      }
    });
  }, []);

  const updateInvestType = useCallback(async (bizData, setState) => {
    HttpAction({
      url: "api/admin/biz/type/name",
      method: "post",
      data: {
        typeCode: bizData.bizTypeCode,
        modifiedName: bizData.bizTypeModifiedName,
      },
    }).then((res) => {
      if (res.code === 200) {
        setState({ type: "SAVE", state: true });
      } else {
        setState(false);
      }
    });
  }, []);

  const updateFundImage = useCallback(async (fundImageData, setState) => {
    axios.defaults.baseURL = process.env.REACT_APP_API_URL;
    await axios
      .post(`api/admin/invest/category-content/modify`, fundImageData, {
        headers: {
          "Content-Type": "multipart/form-data",
          "Access-Control-Allow-Origin": "multipart/form-data",
          Authorization: `Bearer ${localStorage.getItem("jwt")}`,
          Language: process.env.REACT_APP_LANGUAGE,
        },
      })
      .then((res) => {
        if (res.data.code === 200) {
          setState({
            type: "SAVE",
            state: true,
          });
        } else {
          ErroCode[res.code] && (window.location.href = `${process.env.REACT_APP_LANGUAGE === "en"?"/en":"/kr"}/500`);
        }
      });
  }, []);

  const updateInvestment = useCallback((investmentData, setState) => {
    HttpAction({
      url: "api/admin/invest",
      method: "put",
      data: {
        investmentContent: investmentData.investmentContent,
        investmentDisplayYn: investmentData.investmentDisplayYn,
        investmentEndDate: investmentData.investmentEndDate,
        investmentLinkUrl: investmentData.investmentLinkUrl,
        investmentStartDate: investmentData.investmentStartDate,
        investmentTitle: investmentData.investmentTitle,
        investmentTypeCode: investmentData.investmentTypeCode,
        investmentId: investmentData.popupId,
      },
    }).then((res) => {
      if (res.code === 200) {
        setState({
          type: "SAVE",
          state: true,
        });
      } else {
        ErroCode[res.code] && (window.location.href = `${process.env.REACT_APP_LANGUAGE === "en"?"/en":"/kr"}/500`);
      }
    });
  }, []);

  const updateFundDisplayFlg = useCallback(
    (bizList, state, getList, pageInfo, domestic) => {
      HttpAction({
        url: "api/admin/biz/list/display",
        method: "post",
        data: {
          displayTrueList: state ? bizList : [],
          displayFalseList: !state ? bizList : [],
          domestic: domestic
        },
      }).then((res) => {
        if (res.code === 200) {
          getList(pageInfo);
        } else {
          ErroCode[res.code] && (window.location.href = `${process.env.REACT_APP_LANGUAGE === "en"?"/en":"/kr"}/500`);
        }
      });
    },
    []
  );

  const updateFundCategoryDisplayFlg = useCallback(
    (fundList, state, getList, pageInfo) => {
      HttpAction({
        url: "api/admin/fund/modify/display",
        method: "post",
        data: {
          displayTrueList: state ? fundList : [],
          displayFalseList: !state ? fundList : [],
        },
      }).then((res) => {
        if (res.code === 200) {
          getList(pageInfo);
        } else {
          ErroCode[res.code] && (window.location.href = `${process.env.REACT_APP_LANGUAGE === "en"?"/en":"/kr"}/500`);
        }
      });
    },
    []
  );

  const updateCoordinate = useCallback((coordinate, pageInfo, setModal, domestic) => {
    HttpAction({
      url: "api/admin/biz/coordinate",
      method: "post",
      data: {
        bizRegionXPoint: coordinate.x,
        bizRegionYPoint: coordinate.y,
        bizInfoCode: coordinate.bizInfoCode,
        domestic: domestic
      },
    }).then((res) => {
      if (res.code === 200) {
        pageInfo?.type === "DOMESTIC"
          ? getDomesticList(pageInfo)
          : getOverseasList(pageInfo);
        setModal();
      } else {
        ErroCode[res.code] && (window.location.href = `${process.env.REACT_APP_LANGUAGE === "en"?"/en":"/kr"}/500`);
      }
    });
  }, []);

  const updateFundTitle = useCallback((bizInfo, pageInfo, setModal,domestic) => {
    HttpAction({
      url: "api/admin/biz/name",
      method: "post",
      data: {
        bizInfoCode: bizInfo.bizInfoCode,
        bizModifiedName: bizInfo.bizModifiedName,
        domestic: domestic
      },
    }).then((res) => {
      if (res.code === 200) {
        pageInfo?.type === "DOMESTIC"
          ? getDomesticList(pageInfo)
          : getOverseasList(pageInfo);
        setModal();
      } else {
        ErroCode[res.code] && (window.location.href = `${process.env.REACT_APP_LANGUAGE === "en"?"/en":"/kr"}/500`);
      }
    });
  }, []);

  const deleteInvestType = useCallback((typeCode) => {
    HttpAction({
      url: "api/admin/biz/type/name",
      method: "delete",
      params: {
        typeCode: typeCode,
      },
    }).then((res) => {
      if (res.code === 200) {
        getInvestTypeList();
      } else {
        ErroCode[res.code] && (window.location.href = `${process.env.REACT_APP_LANGUAGE === "en"?"/en":"/kr"}/500`);
      }
    });
  }, []);

  const getCategoryList = useCallback(() => {
    HttpAction({
      url: "api/admin/invest/category-content/list",
      method: "get",
      params: {},
    }).then((res) => {
      if (res.code === 200) {
        setCategoryList(res.data);
      } else {
      }
    });
  }, []);

  const updateFund = useCallback(async (fundData, setState) => {
    axios.defaults.baseURL = process.env.REACT_APP_API_URL;
    await axios
      .post(`api/admin/fund/modify`, fundData, {
        headers: {
          "Content-Type": "multipart/form-data",
          "Access-Control-Allow-Origin": "multipart/form-data",
          Authorization: `Bearer ${localStorage.getItem("jwt")}`,
          Language: process.env.REACT_APP_LANGUAGE,
        },
      })
      .then((res) => {
        if (res.data.code === 200) {
          setState({
            type: "SAVE",
            state: true,
          });
        } else {
          ErroCode[res.code] && (window.location.href = `${process.env.REACT_APP_LANGUAGE === "en"?"/en":"/kr"}/500`);
        }
      });
  }, []);

  const value = {
    state: {
      investment,
      fund,
      fundList,
      overseasList,
      domesticList,
      fundImage,
      investTypeList,
      categoryList,
      searchDomesticCondition,
      searchOverseasCondition,
    },
    actions: {
      getFund,
      getFundList,
      getInvestment,
      getDomesticList,
      getOverseasList,
      getFundImage,
      getInvestTypeList,
      createInvestment,
      updateInvestment,
      updateFundDisplayFlg,
      deleteInvestType,
      updateInvestType,
      updateFundImage,
      getCategoryList,
      updateCoordinate,
      updateFundTitle,
      updateFund,
      loadFund,
      updateFundCategoryDisplayFlg,

      getDomesticCondition,
      getOverseasCondition,
    },
  };

  return (
    <InvestmentContext.Provider value={value}>
      {children}
    </InvestmentContext.Provider>
  );
};

const { Consumer: InvestmentConsumer } = InvestmentContext;

export { InvestmentProvider, InvestmentConsumer, InvestmentContext };

export default InvestmentContext;
